import {Injectable} from '@angular/core';
import {ApiService} from '~/app/core/common/services/api.service';
import { HttpClient } from '@angular/common/http';
import {OrderItem} from '~/app/core/common/models/orderItem';
import {Categories} from '~/app/core/common/models/catigories';
import {GoogleAnalyticsService} from '~/app/core/common/services/google-analytics.service';
import {BaseService} from '~/app/core/common/services/base.service';
import {ApplicationSettingsHelper} from '~/app/shared/helpers/application-settings-helper';
import {InternetConnectionService} from '~/app/shared/services/internet-connection.service';
import {ErrorApiService} from '~/app/core/common/test/error-api.service';
import {Serializer} from '~/app/core/common/serializers/serializer';
import { map} from 'rxjs/operators';
import {OrderItemSerializer} from '~/app/core/common/serializers/OrderItemSerializer';
import {OrderItemInsert} from "~/app/core/common/models/orderItemInsert";

@Injectable({
    providedIn: 'root'
})
export class OrderItemService extends BaseService {

    allItemNumbersURL: string;
    private _orderItems: OrderItem[];
    private _objectCategoryArray: any[];

    constructor(public http: HttpClient,
                public apiService: ApiService,
                public googleAnalyticsService: GoogleAnalyticsService,
                public internetConnectionService: InternetConnectionService,
                public errorApiService: ErrorApiService,
                public applicationSettingsHelper: ApplicationSettingsHelper) {
        super(http,
            googleAnalyticsService,
            internetConnectionService,
            errorApiService,
            applicationSettingsHelper);
    }

    get orderItems(): OrderItem[] {
        return this._orderItems;
    }

    set orderItems(value: OrderItem[]) {
        this._orderItems = value;
    }

    get objectCategoryArray(): any[] {
        return this._objectCategoryArray;
    }

    set objectCategoryArray(value: any[]) {
        this._objectCategoryArray = value;
    }

    async downloadAllItemsByStoreNumber(store_number: string, tracking_id: string): Promise<OrderItem[]> {
        this.setAllItemNumbersURL(store_number, tracking_id);
        this.orderItems = await this.callAllItemsByStoreNumberWebService(this.allItemNumbersURL);
        this.objectCategoryArray = await this.getCategories();
        return this.orderItems;
    }

    public setAllItemNumbersURL(store_number: string, tracking_id: string) {
        this.allItemNumbersURL = this.apiService.allItemNumbersURL.replace('store_number', store_number).replace('tracking_id', tracking_id);
    }

    public callAllItemsByStoreNumberWebService(url: string) {
        return this.getHttp(
            'callAllItemsByStoreNumberWebService',
            'order-item-service', url)
            .pipe(map((data: any) => this.convertData(data)))
            .toPromise()
            .then(result => result)
            .finally(() => {
            });
    }

    public resetCategoryArray() {
        this.objectCategoryArray.forEach((item) => {
            if (item.isEnabled) {
                item.isEnabled = false;
            }
        });
    }

    public getCategories(): object[] {
        const categoryArray = new Array<Categories>();
        this.orderItems.map((value, index, array) => {
            const category = value.categories;
            if (category !== null && category !== undefined) {
                const listOfCategoryNames = Object.keys(category);
                listOfCategoryNames.forEach((values) => {
                    if (categoryArray.map(item => item.category).indexOf(values) === -1) {
                        categoryArray.push({category: values, isEnabled: false});
                    }
                });
            }
        });
        return categoryArray;
    }


    public async uploadOrder(itemsToInsert: OrderItemInsert) {
        console.log('itemsToInsert: ', itemsToInsert);
        const jsonOrder = JSON.stringify(itemsToInsert);
        console.log('jsonOrder for upload order: ', jsonOrder);

        return this.postHttpJson(
            'uploadOrder',
            'order-item-service',
            this.apiService.uploadOrderURL,
            jsonOrder).toPromise().then((callResult) => {
            return callResult;
        });
    }


    public convertData(data: any, customSerializer?: Serializer): OrderItem[] {
        const orderItemSerializer = new OrderItemSerializer()
        return data.map(item => orderItemSerializer.fromJson(item));
    }

    postFile(fileToUpload: File) {
        const endpoint = 'your-destination-url';
        const formData: FormData = new FormData();
        formData.append('fileKey', fileToUpload, fileToUpload.name);

        console.log('endPoint: ', endpoint);
        console.log('formData: ', formData);

        return this.httpClient
            .post(endpoint, formData,)
            .pipe(map(() => {
                return true;
            }));
    }
}

